import { gridPageCountSelector, gridPageSelector, useGridApiContext, useGridSelector } from '@mui/x-data-grid-pro';
import { Pagination as MuiPagination } from '@mui/material';

export function DataGridPagination() {
  const apiReference = useGridApiContext();
  const page = useGridSelector(apiReference, gridPageSelector);
  const pageCount = useGridSelector(apiReference, gridPageCountSelector);

  return (
    <MuiPagination
      count={pageCount}
      page={page + 1}
      onChange={(_, value) => apiReference.current.setPage(value - 1)}
      variant='outlined'
      shape='rounded'
    />
  );
}
